import { useMutation } from '@tanstack/react-query';
import { sendLogLogin } from '../api/sendLogLogin';

export const useSendLogLogin = () => {
    return useMutation({
        mutationFn: sendLogLogin,
        retry: false,
    });
};
